import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import { Flex, useResponsiveValue } from "@smile2impress/components";
import { UTSLocaleToLanguage } from "@smile2impress/attraction-constants";
import { useUTSLocaleContext } from "context/utsLocaleContext";

import {
    TrustpilotProps,
    TrustpilotWidgetTheme,
    TrustpilotWidgetVariant,
} from "./Trustpilot.types";
import { getWidgetProps } from "./utils";

const defaultVariant = TrustpilotWidgetVariant.MINI;
const defaultTheme = TrustpilotWidgetTheme.LIGHT;

export const TrustpilotWidget: FunctionComponent<TrustpilotProps> = (props) => {
    const {
        variant = defaultVariant,
        theme = TrustpilotWidgetTheme.LIGHT,
        ...rest
    } = props;
    const ref = useRef(null);
    const { locale } = useUTSLocaleContext();
    const language = UTSLocaleToLanguage[locale];
    const [isClient, setIsClient] = useState(false);

    const currentVariant = useResponsiveValue(variant) || defaultVariant;
    const currentTheme = useResponsiveValue(theme) || defaultTheme;

    useEffect(() => {
        if (isClient && window?.Trustpilot) {
            window?.Trustpilot?.loadFromElement(ref.current, true);
        }
    }, [currentVariant, currentTheme, isClient]);

    useEffect(() => {
        setIsClient(true);
    }, []);

    return (
        <>
            {isClient && (
                <Flex
                    alignContent="flex-start"
                    alignItems="flex-start"
                    key={currentVariant + currentTheme}
                    ref={ref}
                    className="trustpilot-widget"
                    data-locale={locale}
                    data-review-languages={language}
                    data-businessunit-id="5d665003f7118a000133c65a"
                    data-theme={currentTheme}
                    {...getWidgetProps(currentVariant, locale)}
                    {...rest}
                />
            )}
        </>
    );
};
